import React from 'react';
import { Card, Statistic, Tag } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

// Simple Sparkline SVG Component
const Sparkline = ({ color, data }) => {
  if (!data || data.length < 2) return null;

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const stepX = 100 / (data.length - 1);

  const points = data.map((d, i) => {
    const x = i * stepX;
    // If range is 0 (flat line), center it vertically
    const y = range === 0 ? 20 : 40 - ((d - min) / range) * 30 - 5; // Leave 5px padding top/bottom
    return `${x},${y}`;
  }).join(' ');

  const pathD = `M ${points}`;
  const fillD = `${pathD} V 40 H 0 Z`;

  return (
    <svg width="100%" height="40" viewBox="0 0 100 40" preserveAspectRatio="none" style={{ opacity: 0.5 }}>
      <path
        d={pathD}
        fill="none"
        stroke={color}
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d={fillD}
        fill={color}
        fillOpacity="0.1"
      />
    </svg>
  );
};

const MetricCard = ({ title, value, prefix, color, trend, suffix, data }) => (
  <Card styles={{ body: { padding: '20px 24px' } }} style={{ height: '100%', overflow: 'hidden', position: 'relative' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
      <div style={{ padding: 12, borderRadius: 12, background: `${color}15`, color: color }}>
        {React.cloneElement(prefix, { style: { fontSize: 24 } })}
      </div>
      {trend !== undefined && trend !== null && (
        <Tag color={trend >= 0 ? 'success' : 'error'} style={{ borderRadius: 12, border: 'none' }}>
          {trend >= 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {Math.abs(trend)}%
        </Tag>
      )}
    </div>
    <Statistic
      title={<span style={{ fontSize: 13, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{title}</span>}
      value={value}
      valueStyle={{ fontSize: 28, fontWeight: 700, color: '#1e293b' }}
      suffix={suffix}
    />
    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
      <Sparkline color={color} data={data} />
    </div>
  </Card>
);

export default MetricCard;
